module.exports = __webpack_public_path__ + "static/media/13_tiger_horse.32da62d5.png";